import API from "./API";

import BaseService from "./BaseService";

/**
 * @typedef {import("@/types/services/LibraryServiceTypes.mjs").SiteConfig} SiteConfig
 */

class LibraryService extends BaseService {
  constructor() {
    super();
  }

  /**
   *
   * @param {*} data
   * @returns {Promise<{
   *  response: number,
   *  sites: Array<SiteConfig>
   * }>}
   */
  loadSites(data) {
    return API.get("lib/sites", null, this.getToken());
  }

  loadDesignExport(exportKey) {
    return API.get("designexports/" + exportKey, null, this.getToken());
  }
}

export default new LibraryService();
